import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const masterDataCurrencyListService = (
  params: Types.MasterDataCurrencyListRequest
) =>
  RestAPIClient.call<Types.MasterDataCurrencyListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

// export const leaveTypeCreateService = (params: Types.LeaveTypeCreateRequest) =>
//   RestAPIClient.call<unknown>({
//     method: HTTPRequestMethods.POST,
//     url: Paths.Create,
//     config: {
//       requireAuthentication: true,
//     },
//     data: params,
//   });

// export const leaveTypeUpdateService = (params: Types.LeaveTypeUpdateRequest) =>
//   RestAPIClient.call<unknown>({
//     method: HTTPRequestMethods.PUT,
//     url: `${Paths.Update}/${params.id}`,
//     config: {
//       requireAuthentication: true,
//     },
//     data: params,
//   });
